import { Model as BaseModel } from 'vue-api-query'

export default class Model extends BaseModel {

  // define a base url for a REST API
  baseURL () {
    return window.Laravel.backofficeApi
  }

  // implement a default request method
  request (config) {
    return this.$http.request(config)
  }

  /**
   * @param {string[]} columns Keys of the columns to export, sent as a single comma separated
   *                           parameter. An empty list exports every column.
   */
  exportUrl (columns = []) {
    const query = this._builder.query();
    const params = columns.length
      ? `export=1&columns=${columns.map(encodeURIComponent).join(',')}`
      : 'export=1';

    return this.endpoint() + ( query ? `${query}&` : `?` ) + params
  }

  exportColumnsUrl () {
    const query = this._builder.query();
    return this.endpoint() + ( query ? `${query}&` : `?` ) + 'export_columns=1'
  }
}